import React from 'react'
import moment from 'moment'
import BaseModal from '../base-modal'
import { Details, Row, Block } from '../details/details'

const constraints = {
    'width': '760',
    'minWidth': '760px'
}

const titleWithLink = (title, image) => {
    const url = image ? image.url : null
    return (
        <span>
            {title}
            <a href={url} target='_blank' disabled={!url} style={{ marginLeft: '5px' }}>
                View
            </a>
        </span>
    )
}

// ImageBlock component
const ImageBlock = ({ image, title }) => (
    <Block title={titleWithLink(title, image)} style={{ position: 'relative' }}>
        {image && image.url ? (
            <div className="servicing-images">
                <img
                    src={image.url}
                    style={{ maxWidth: '100%', maxHeight: '75%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                />
                <div style={{ marginTop: '8px', fontSize: '0.85em', textAlign: 'center' }}>
                    {image.display_taken_at || image.displayTakenAt || image.createdAt ? (
                        <p className="timestamp" style={{ margin: 0 }}>
                            <strong>Taken at:</strong> {moment(image.display_taken_at || image.displayTakenAt || image.createdAt).format('MMMM D, YYYY [at] h:mm A')}
                        </p>
                    ) : null}

                    {/* Admin Fallback Notice */}
                    {(image.is_fallback || image.isFallback) && (
                        <span style={{ color: '#d9534f', fontSize: '0.8em', display: 'block', marginTop: '2px', fontWeight: 'bold' }}>Photo capture time not found. Upload time used instead.
                            ⚠️
                        </span>
                    )}
                </div>
            </div>
        ) : null}
    </Block>
)

const fixUrl = url => (url ? url.replace(/https\%3A.*\//, '') : '')

export default ({
    servicing: { beforeImage = {}, afterImage = {}, beforeAfters = [] } = {},
    loading,
    handleClose,
    modalTitle,
}) => (
    <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName='issue-create-container'
    >
        {loading ? (
            <p>Loading...</p>
        ) : !beforeImage.url && !afterImage.url && beforeAfters.length === 0 ? (
            <p>No images</p>
        ) : (
            <Details>
                {(beforeImage.url || afterImage.url) && (
                    <Row key="legacy-before-image">
                        <ImageBlock title="Before Image" image={{ ...beforeImage, url: fixUrl(beforeImage.url) }} />
                        <ImageBlock title="After Image" image={{ ...afterImage, url: fixUrl(afterImage.url) }} />
                    </Row>
                )}

                {beforeAfters.map(({ id, beforeImage, afterImage, time_taken_between, timeTakenBetween }) => {
                    const elapsed = time_taken_between || timeTakenBetween
                    const hasBefore = beforeImage && beforeImage.url
                    const hasAfter = afterImage && afterImage.url
                    return (
                        <div key={id} style={{ marginBottom: '20px', borderBottom: '1px solid #e0e0e0', paddingBottom: '12px' }}>
                            <Row>
                                <ImageBlock title="Before Image" image={beforeImage} />
                                <ImageBlock title="After Image" image={afterImage} />
                            </Row>

                            {/* Time Taken Banner */}
                            {hasBefore && hasAfter && (
                                <div
                                    style={{
                                        textAlign: 'center',
                                        backgroundColor: '#f8f9fa',
                                        border: '1px solid #e9ecef',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        marginTop: '8px',
                                        fontSize: '0.9em'
                                    }}
                                >
                                    <strong>⏱️ Time Taken (Before → After):</strong> {elapsed || 'N/A'}
                                </div>
                            )}
                        </div>
                    )
                })}
            </Details>
        )}
    </BaseModal>
)



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-images.js